export function getStepFieldIds (key:string) {
    let elemArr:string[] =[];
    document.querySelectorAll('#stepBody input, #stepBody select, #stepBody textarea, #stepBody div.signature, #stepBody .fileUpload-result').forEach((o,i) => elemArr.push(o.id));

    return elemArr.includes(key);
    
};